<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To Dr Gregory Leadbetter who challenged me to write this when<br/>
I didn’t feel able.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?ed50d4c0